import { Create, Resource, useRedirect } from "react-admin";
import { StudentDetails } from "../details/StudentDetails";
import { useAutovioContext } from "../hooks/useAutovioContext";
import { Box, Paper } from "@mui/material";
import { Column } from "../misc/Column";
import { CreateStudentForm, CreateStudentFormValues } from "../details/student/CreateStudentForm";
import { grants } from "../backoffice.access_control";
import { AccessDenied } from "../misc/AccessDenied";
import { BackofficeRecordTitle } from "../misc/BackofficeRecordTitle";
import { Student } from "../providers/studentsProvider";
import { Form2 } from "../misc/Form2";
import { DefaultList } from "../misc/DefaultList";

function _CreateStudentForm() {
  const [{ drivingSchoolId }] = useAutovioContext();
  const redirect = useRedirect();

  if (!grants.has("Student:create")) {
    return <AccessDenied />;
  }

  if (!drivingSchoolId) {
    return (
      <Box className="centered">
        <Column sx={{ alignItems: "center" }}>Bitte wähle eine Fahrschule aus.</Column>
      </Box>
    );
  }

  return (
    <Create
      title={<BackofficeRecordTitle />}
      resource="students"
      mutationOptions={{
        onSuccess: (data: Student) => {
          showSuccessToast("Fahrschüler erfolgreich erstellt.");
          redirect(`/students/${data.id}`);
        },
        onError: (error: Error) => {
          showErrorToast("Fehler beim Erstellen des Fahrschülers.");
          console.error("Failed to create student.", error);
        },
      }}
      transform={(data: CreateStudentFormValues) => {
        return {
          ...data,
          drivingSchoolId,
        };
      }}
    >
      <Paper sx={{ p: 2 }}>
        <Form2>
          <CreateStudentForm />
        </Form2>
      </Paper>
    </Create>
  );
}

export const studentsResource = (
  <Resource
    key="students"
    name="students"
    list={DefaultList}
    create={_CreateStudentForm}
    edit={StudentDetails}
    options={{
      label: "Fahrschüler",
      createTitle: "Neuer Fahrschüler",
      noEntriesText: "Noch kein Fahrschüler vorhanden.",
      noMatchingEntriesText: "Keine passenden Fahrschüler gefunden.",
    }}
    recordRepresentation={(student) => student.name.replaceAll(" ", "\u00A0")}
  />
);
